<template>
  <section class="c-panel product" v-bind:class="headerClass">
    <slot name="panel-section"/>

    <header v-if="title || $slots.extras" @click="toggleVariationInfo" class="c-panel__header" v-bind:class="{ onlyHeader: (!withBody && !withFooter) || !show }">
      <div :class="titleCustomClass">
        <span v-if="onClick" class="check-box" @click="select" v-bind:class="selectClass"></span>
        <slot v-else name="header-left"/>
        <h2 class="c-panel__title v-middle">
          <div v-if="!to && useAcordion && titleChangeble" v-html="title"></div>
          <div v-else-if="!to && useAcordion && !titleChangeble" v-once v-html="title"></div>
          <div v-else-if="!to" v-html="title"></div>
          <router-link v-else :to="to" class="hint hint--right" data-label="Clique aqui para acessar" v-html="title"/>
        </h2>
      </div>

      <i v-bind:class="toggleIconClass" class="u-floatRight icon-toggle" v-if="useToggleIcon"></i>
      <slot name="header-right"/>
    </header>
    <div class="c-panel__body" v-show="show" v-if="withBody">
      <slot/>
    </div>
    <footer v-if="$slots.footer && withFooter" class="c-panel__footer">
      <slot name="footer"/>
    </footer>

    <slot name="floor"/>
  </section>
</template>

<script>
  export default {
    data: () => ({
      selected: false,
      show: true
    }),
    props: {
      title: {
        type: String
      },
      onClick: {
        type: Function,
        required: false
      },
      defaultSelect: {
        type: Boolean,
        default: false
      },
      to: {
        type: Object,
        required: false
      },
      blockSelect: {
        type: Boolean,
        default: false
      },
      useAcordion: {
        type: Boolean,
        default: false
      },
      acordionDefault: {
        type: Boolean,
        default: false
      },
      titleChangeble: {
        type: Boolean,
        default: false
      },
      withBody: {
        type: Boolean,
        default: true
      },
      withFooter: {
        type: Boolean,
        default: true
      },
      useToggleIcon: {
        type: Boolean,
        default: false
      },
      titleCustomClass: {
        type: String,
        required: false
      },
      blockToggle: {
        type: Boolean,
        default: false
      }
    },
    created () {
      this.selected = this.defaultSelect
    },
    mounted () {
      if (this.useAcordion) {
        this.show = this.acordionDefault
      }
    },
    methods: {
      select (event) {
        if (!this.onClick ||
          event.target instanceof HTMLInputElement ||
          event.target instanceof HTMLTextAreaElement ||
          event.target instanceof HTMLSelectElement ||
          event.target.parent instanceof HTMLButtonElement ||
          event.target.classList.value.indexOf('icon') !== -1 ||
          this.blockSelect
        ) {
          return false
        }

        if (this.useAcordion) {
          this.selected = !this.selected
          this.onClick(this.selected)
        }
      },
      toggleVariationInfo (event) {
        if (this.blockToggle && !this.show) {
          return false
        }

        if (!this.useAcordion) {
          if (!this.onClick ||
            event.target instanceof HTMLInputElement ||
            event.target instanceof HTMLTextAreaElement ||
            event.target instanceof HTMLSelectElement ||
            event.target.parent instanceof HTMLButtonElement ||
            event.target.classList.value.indexOf('icon') !== -1 ||
            this.blockSelect
          ) {
            return false
          }
          this.selected = !this.selected
          this.onClick(this.selected)
        }

        if (event.target.classList.value.indexOf('check-box') !== -1 || !this.useAcordion || event.target.classList.value.indexOf('ignore-acordion') !== -1) {
          return false
        }

        this.show = !this.show
      }
    },
    computed: {
      headerClass () {
        return {
          'click': this.onClick || this.useAcordion,
          'selected': this.selected
        }
      },
      selectClass () {
        return {
          'checked': this.selected
        }
      },
      toggleIconClass () {
        return {
          'icon-circle-up': this.show,
          'icon-circle-down': !this.show
        }
      }
    },
    watch: {
      defaultSelect (value) {
        this.selected = value
      }
    }
  }
</script>

<style lang="sass" scoped>
  .click
    header
      cursor: pointer

  .v-middle
    display: inline-block
    vertical-align: middle

  .form-checkbox
    margin: 0

  .icon-circle-down, .icon-circle-up
    font-size: 30px

  .product
    border: 1px solid transparent

    &.selected
      border: 1px solid rgba(0, 0, 0, 0.3)
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)

  .onlyHeader
    &::after
      content: none
</style>



// WEBPACK FOOTER //
// Panel.vue?fa746670